import { Box, Button, CircularProgress, SxProps } from '@mui/material';

export const GithubCodingCard = ({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export const LoadingButton = ({
  loading,
  onClick,
  label,
  loadingText = 'Loading...',
}: {
  loading: boolean;
  onClick: () => void;
  label: string;
  loadingText?: string;
}) => {
  return (
    <Button variant='contained' fullWidth onClick={onClick} disabled={loading}>
      {loading && <CircularProgress size={18} color='inherit' sx={{ mr: 1 }} />}
      {loading ? loadingText : label}
    </Button>
  );
};
